<template>
  <div :id="componentId" class="sp2-module-4" :style="moduleStyle">
    <div class="sp2-module-4-wrap">
      <div
        v-for="(item, index) in displayList"
        :key="index"
        class="sp2-person-item"
      >
        <div class="sp2-person-avatar-wrap">
          <img
            v-if="item.avatarUrl"
            class="sp2-person-avatar"
            referrerpolicy="no-referrer"
            :src="item.avatarUrl"
          />
          <div v-else class="sp2-person-avatar-placeholder">头像</div>
        </div>
        <div class="sp2-person-name">{{ item.name || '姓名' }}</div>
        <div class="sp2-person-divider" />
        <div class="sp2-person-position">{{ item.position || '职位' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpTwoModule4',
  props: {
    componentId: {
      type: String,
      default: 'sp_two_module_4'
    }
  },
  data() {
    return {
      backgroundColor: '#fff',
      list: [
        { avatarUrl: '', name: '宛 枫', position: '中国品牌杂志社 总编辑' },
        { avatarUrl: '', name: '宛 枫', position: '中国品牌杂志社 总编辑' },
        { avatarUrl: '', name: '宛 枫', position: '中国品牌杂志社 总编辑' },
        { avatarUrl: '', name: '宛 枫', position: '中国品牌杂志社 总编辑' },
        { avatarUrl: '', name: '宛 枫', position: '中国品牌杂志社 总编辑' }
      ]
    };
  },
  computed: {
    displayList() {
      return (this.list || []).slice(0, 5);
    },
    moduleStyle() {
      return {
        backgroundColor: this.backgroundColor
      };
    }
  }
};
</script>

<style scoped>
.sp2-module-4 {
  position: relative;
  width: 100%;
  padding: 16px 0;
  box-sizing: border-box;
  overflow: hidden;
}

.sp2-module-4-wrap {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 20px 8px;
  width: calc(100% - 24px);
  margin: 0 auto;
  padding: 24px 0;
  box-sizing: border-box;
}

.sp2-person-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sp2-person-item:nth-child(-n+2) {
  grid-column: span 3;
}

.sp2-person-item:nth-child(n+3) {
  grid-column: span 2;
}

.sp2-person-avatar-wrap {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  background: #e0e0e0;
}

.sp2-person-avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.sp2-person-avatar-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
}

.sp2-person-name {
  margin-top: 10px;
  font-size: 16px;
  color: #000000;
  line-height: 1.4;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.sp2-person-divider {
  width: 24px;
  height: 3px;
  margin-top: 6px;
  background: linear-gradient(90deg, #1F48BC 0%, #6592E3 100%);
  border-radius: 2px;
}

.sp2-person-position {
  margin-top: 6px;
  font-size: 12px;
  color: #666666;
  line-height: 1.5;
  text-align: center;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  max-width: 100%;
}
</style>
